import { Col, Form } from "react-bootstrap";
import LoadingButton from "../../../../components/Loading/LoadingButton";
import DateFilter from "../../../../components/tools/DateFilter";

export default function PayLinkAgentOrdersFilters({
  filters,
  isFetching,
  refetch,
}) {
  return (
    <div className="d-flex flex-wrap row-gap-2 bs card-shadow py-4 px-3 rounded-1">
      <Col xs={12} sm={6} md={4} xl={3} className="px-1">
        <Form.Label>تعداد نمایش</Form.Label>
        <Form.Select
          value={filters.get("items")}
          onChange={e => filters.set("items", e.target.value)}
        >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </Form.Select>
      </Col>

      <Col xs={12} sm={6} md={4} xl={3} className="px-1">
        <Form.Label>شماره سفارش</Form.Label>
        <Form.Control
          value={filters.get("numberParcel")}
          onChange={e => filters.set("numberParcel", e.target.value)}
        />
      </Col>

      <div className="w-100 d-flex flex-wrap row-gap-2">
        <Col xs={12} sm={6} md={4} xl={3} className="px-1">
          <DateFilter
            value={filters.get("startDate")}
            label="از تاریخ"
            onChange={value => filters.set("startDate", value)}
          />
        </Col>

        <Col xs={12} sm={6} md={4} xl={3} className="px-1">
          <DateFilter
            value={filters.get("endDate")}
            label="تا تاریخ"
            onChange={value => filters.set("endDate", value)}
          />
        </Col>
      </div>

      <div className="w-100">
        <LoadingButton
          center
          className="btn-outline-primary"
          isLoading={isFetching}
          title={isFetching ? "در حال دریافت" : "اعمال فیلتر"}
          onClick={refetch}
        />
      </div>
    </div>
  );
}
